import { wilson } from './statistics.mjs';
import { countryEntity } from './entities.mjs';

// Explicit integration/configuration failures only, never ordinary declines.
const technicalKinds = [
  { id: 'google_pay_token', name: 'неверный формат токена Google Pay', match: /google\s*pay token format not valid/i },
  { id: 'routing', name: 'нет активного канала для терминала', match: /no active channel for (?:the )?given terminal/i },
  { id: 'xml', name: 'ошибки разбора XML в платёжной интеграции', match: /(?:\bmpi\b.*(?:invalid xml|unmarshall)|(?:invalid xml|unmarshall).*\bmpi\b)/i },
];
export function technicalErrors(data) {
  const rows = data.errors || [];
  if (data.inconsistent || !Number.isSafeInteger(data.failed) || data.failed <= 0 ||
    rows.some(row => !Number.isSafeInteger(row.count) || row.count < 0) ||
    rows.reduce((sum, row) => sum + row.count, 0) > data.failed) return [];
  return technicalKinds.map(kind => {
    const errors = rows.filter(row => kind.match.test(row.label)).map(row => ({ label: row.label, count: row.count }))
      .sort((a, b) => b.count - a.count);
    return { id: kind.id, name: kind.name, errors, count: errors.reduce((sum, row) => sum + row.count, 0) };
  }).filter(row => row.count >= 3 && (row.count / data.failed >= 0.01 || row.count >= 10))
    .sort((a, b) => b.count - a.count || a.id.localeCompare(b.id));
}

export function emailDeclines(data) {
  if (data.inconsistent || !Number.isSafeInteger(data.total) || !Number.isSafeInteger(data.success) ||
    !Number.isSafeInteger(data.failed) || data.success < 0 || data.failed < 0 || data.total !== data.success + data.failed) return [];
  return (data.emails || []).flatMap(row => {
    const interval = wilson(row.success, row.total);
    const failures = row.total - row.success;
    if (!interval || row.total > data.total || row.success > data.success || failures > data.failed ||
      failures < 5 || failures / row.total < 0.5 || interval.upper >= 0.8) return [];
    const severity = failures >= 10 && failures / row.total >= 0.8 && interval.upper < 0.5 ? 'critical' : 'warning';
    const rounded = value => Math.round(value * 100) / 100;
    const conservativeExtraDeclines = (0.8 - interval.upper) * row.total;
    return [{ entity: row.entity, severity, evidence: {
      kind: 'email_declines', attempts: row.total, failures,
      currentRate: rounded(row.success / row.total * 100), failureRate: rounded(failures / row.total * 100),
      interval95: { lower: rounded(interval.lower * 100), upper: rounded(interval.upper * 100) },
      targetSupported: true, trendSupported: false,
      conservativeExtraDeclines: rounded(conservativeExtraDeclines), rankingImpact: conservativeExtraDeclines,
    } }];
  });
}

function countries(data) {
  if (!data || data.inconsistent || !(data.total >= 200)) return null;
  const rows = data.segments.filter(row => row.kind === 'country');
  const keys = rows.map(row => row.label.trim().toUpperCase());
  if (new Set(keys).size !== rows.length || rows.some(row => !Number.isSafeInteger(row.total) ||
    !Number.isSafeInteger(row.success) || row.success < 0 || row.total < row.success)) return null;
  const total = rows.reduce((n, row) => n + row.total, 0);
  const success = rows.reduce((n, row) => n + row.success, 0);
  // Countries exclude expired attempts: comparisons stay inside this breakdown.
  if (total < data.total * 0.8 || total > data.total || success > data.success || total - success > data.failed) return null;
  return { rows, total, success, sourceTotal: data.total };
}
function concentration(group, row) {
  const restTotal = group.total - row.total, failures = row.total - row.success;
  const restFailures = group.total - group.success - failures;
  if (row.total < 100 || restTotal < 100 || failures < 20) return null;
  const rate = failures / row.total, restRate = restFailures / restTotal;
  const excess = failures - restRate * row.total;
  if (rate < restRate * 2 || rate - restRate < 0.03 || excess < 20 ||
    wilson(failures, row.total).lower <= wilson(restFailures, restTotal).upper) return null;
  return { attempts: row.total, failures, trafficShare: row.total / group.total * 100,
    failureShare: failures / (group.total - group.success) * 100, failureRate: rate * 100,
    restFailureRate: restRate * 100, excessVsRest: excess, coverage: group.total / group.sourceTotal * 100 };
}
export function countryConcentrations(current, previous) {
  const group = countries(current), old = countries(previous);
  if (!group) return [];
  return group.rows.flatMap(row => {
    const entity = countryEntity(row.label), evidence = concentration(group, row);
    if (!entity || !evidence) return [];
    const before = old?.rows.find(item => item.label.trim().toUpperCase() === entity.value);
    return [{ entity, evidence: { ...evidence, repeated: !!before && !!concentration(old, before) } }];
  }).sort((a, b) => b.evidence.excessVsRest - a.evidence.excessVsRest);
}
